import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-service-definition',
  templateUrl: './delete-service-definition.component.html',
  styleUrls: ['./delete-service-definition.component.css']
})
export class DeleteServiceDefinitionComponent implements OnInit {

  serviceData: any= []
  serviceId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];

  constructor( private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllServices()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllServices();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllServices();
  }

  getAllServices(){
    this.generic_service.getAllPlans().subscribe(
      (response:any)=>{
        this.serviceData = response.response;
        console.log(response)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }

  del(id:any){
    this.serviceId = id;
  }

  deleteService(){
    this.generic_service.deletePlan(this.serviceId).subscribe(
      (response:any)=>{
        console.log(response);
        this.getAllServices()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

}
